import React from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "./ConfirmDeactivateModal.css";

const DispatchOrderModal = ({ show, onClose, onSubmit, date, time, setDate, setTime }) => {
  const { t } = useTranslation();
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="dispatch-order-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("admin.orders.dispatchOrder")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onSubmit} >
          <Row className="g-3" style={{padding:'24px 10px'}}>
            <Col md={6}>
              <div className="form-icon-input">
                <Form.Control
                  type="date"
                  required
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  placeholder={t("common.date")}
                />
                
              </div>
            </Col>
            <Col md={6}>
              <div className="form-icon-input">
                <Form.Control
                  type="time"
                  required
                  value={time}
                  onChange={(e) => setTime(e.target.value)}
                  placeholder={t("common.time")}
                />
                
              </div>
            </Col>
          </Row>

          <div className="d-flex justify-content-end gap-3 mt-4">
            <Button variant="light" onClick={onClose} className="btn-no mr-2">
              {t("common.cancel")}
            </Button>
            <Button variant="primary" type="submit" className="btn-yes">
              {t("common.submit")}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default DispatchOrderModal;
